/**
 * @description Slider trombinoscope
 */

/* global SliderInt */

(() => {
	// Variables
	const allSlideLead = document.querySelectorAll(
		'.slide-int-portraits-container .slide-lead'
	);
	const allSlidePersonLead = document.querySelectorAll(
		'.slide-int-personnes-container .slide-lead'
	);

	const checkSummary = () => {
		const summary =
			document.querySelector('[data-selector-page-summary]') || null;

		const allSlideItem = document.querySelectorAll(
			'.slide-int-portraits-container .slide-item'
		);

		allSlideItem.forEach((el) => {
			summary !== null
				? el.classList.add('col-lg-4')
				: el.classList.add('col-lg-3');
		});
	};

	// Functions
	const clickShowMore = (el) => {
		el.parentNode
			.querySelector('.showMore')
			.addEventListener('click', () => {
				if (el.classList.contains('showLess')) {
					el.classList.remove('showLess');
					el.querySelector('p, ul').style.removeProperty('overflow');
					el.parentNode.querySelector('.showMore').innerHTML =
						'Lire la suite';
					el.style.setProperty('max-height', `calc(1.15rem * 3)`);
				} else {
					el.classList.add('showLess');
					el.querySelector('p, ul').style.setProperty('overflow', 'auto');
					el.parentNode.querySelector('.showMore').innerHTML =
						'Afficher moins';
					el.style.removeProperty('display');
					el.style.removeProperty('max-height');
				}
			});
	};

	const observer = new ResizeObserver((entries) => {
		for (const entry of entries) {
			entry.target.classList[
				entry.target.scrollHeight > entry.contentRect.height + 1
					? 'add'
					: 'remove'
			]('truncated');
		}
	});

	// GO 🚀
	const init = () => {
		allSlideLead.forEach((slide) => {
			slide.style.setProperty('max-height', `calc(1.15rem * 3)`);
			observer.observe(slide);
			clickShowMore(slide);
			checkSummary(slide);
		});

		allSlidePersonLead.forEach((slide) => {
			slide.style.setProperty('max-height', `calc(1.15rem * 3)`);
			observer.observe(slide);
			clickShowMore(slide);
		});
		return new SliderInt('slide-int-equipements-container', 'trombi', {
			xl: 2,
			lg: 2,
			md: 2,
			sm: 1,
		});
	};

	init();
})();
